import { Box, Theme, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { SxProps } from '@mui/material/styles';
const FormTitle = (props: {
  title?: string | ReactNode;
  subtitle?: string | ReactNode;
  subtitleSx?: SxProps<Theme>;
}) => {
  return <Box sx={{
    textAlign: 'center'
  }} data-sentry-element="Box" data-sentry-component="FormTitle" data-sentry-source-file="FormTitle.tsx">
      {props.title ? <Typography sx={{
      typography: {
        md: 'titleStrong__Wallfund',
        xs: 'headlineStrong__Wallfund'
      }
    }}>
          {props.title}
        </Typography> : null}
      {props.subtitle ? <Typography sx={{
      mt: 'var(--spacing_xxs)',
      typography: {
        md: 'bodyLargeRegular__Wallfund',
        xs: 'bodyRegular__Wallfund'
      },
      ...props.subtitleSx
    }}>
          {props.subtitle}
        </Typography> : null}
    </Box>;
};
export default FormTitle;